import eat from 'model/actions/eat';
import ResourceController from 'controllers/ResourceController';
import Debug from 'debug';
const debug = Debug('controllers:DailyUpdatesController');

const consumeResources = context => {
  const result = eat.execute(context);
  debug(result);
};

const checkForSpecialEvents = () => {
  // Check and trigger any special events for the day
};

const handleDayChange = (daysElapsed, context, setEvent) => {
  debug(daysElapsed, context);

  // Perform daily updates
  consumeResources(context);

  // Daily resource updates from any registered actions
  ResourceController.instance().dailyEffects.forEach(action => {
    const result = action.execute(context, setEvent);
    debug(result);
  });

  // Check for special events

  // More daily update methods as needed
};

export { handleDayChange };
